import { Outlet } from 'react-router-dom';
import { SITE_URL } from '../../lib/config';

export function AuthLayout() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header>
        <div className="max-w-screen-2xl mx-auto px-12 py-6 flex items-center justify-between">
          <a href={SITE_URL} className="flex items-center gap-2">
            <video
              src="/zac-avatar.mp4"
              autoPlay
              loop
              muted
              playsInline
              className="w-8 h-8 rounded-lg object-cover"
            />
            <span className="text-xl font-semibold">Ask <span className="text-primary">Zac</span></span>
          </a>
          <a
            href={SITE_URL}
            className="transition-colors text-sm text-muted-foreground hover:text-foreground"
          >
            Back to askzac.ai
          </a>
        </div>
      </header>
      <Outlet />
    </div>
  );
}
